<template>
  <main class="-mt-32" v-if="loaded">
    <div class="px-4 py-10 pb-12 mx-auto -mt-32 max-w-7xl sm:px-6 lg:px-8">
      <div class="overflow-hidden bg-white shadow sm:rounded-md">
        <div class="bg-white">
          <div
            class="flex flex-wrap items-center justify-between px-4 pt-4 border-b sm:px-6 sm:flex-no-wrap"
          >
            <div class="block">
              <div class="border-gray-200">
                <nav class="flex -mb-px">
                  <a
                    href="#info"
                    @click="tab = 'info'"
                    :class="{
                      'border-indigo-500 text-indigo-500 focus:text-indigo-800 focus:border-indigo-700':
                        tab == 'info',
                      'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300':
                        tab != 'info',
                    }"
                    class="inline-flex items-center px-1 py-4 text-sm font-medium leading-5 text-gray-500 border-b-2 group hover:text-gray-700 hover:border-gray-300 focus:outline-none"
                  >
                    <svg
                      :class="{
                        'text-indigo-500 group-focus:text-indigo-600':
                          tab == 'info',
                        'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600':
                          tab != 'info',
                      }"
                      class="-ml-0.5 mr-2 h-5 w-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    <span>Anagrafica</span>
                  </a>
                  <a
                    href="#files"
                    v-if="patient.id"
                    @click="tab = 'files'"
                    :class="{
                      'border-indigo-500 text-indigo-500 focus:text-indigo-800 focus:border-indigo-700':
                        tab == 'files',
                      'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300':
                        tab != 'files',
                    }"
                    class="inline-flex items-center px-1 py-4 ml-8 text-sm font-medium leading-5 border-b-2 group hover:text-gray-700 hover:border-gray-300 focus:outline-none"
                  >
                    <svg
                      :class="{
                        'text-indigo-500 group-focus:text-indigo-600':
                          tab == 'files',
                        'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600':
                          tab != 'files',
                      }"
                      class="-ml-0.5 mr-2 h-5 w-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z"
                      ></path>
                      <path
                        d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z"
                      ></path>
                    </svg>
                    <span>Allegati</span>
                  </a>
                  <a
                    href="#photos"
                    v-if="patient.id"
                    @click="tab = 'photos'"
                    :class="{
                      'border-indigo-500 text-indigo-500 focus:text-indigo-800 focus:border-indigo-700':
                        tab == 'photos',
                      'border-transparent text-gray-500 focus:text-gray-700 focus:border-gray-300':
                        tab != 'photos',
                    }"
                    class="inline-flex items-center px-1 py-4 ml-8 text-sm font-medium leading-5 border-b-2 group hover:text-gray-700 hover:border-gray-300 focus:outline-none"
                  >
                    <svg
                      :class="{
                        'text-indigo-500 group-focus:text-indigo-600':
                          tab == 'photos',
                        'text-gray-400 group-hover:text-gray-500 group-focus:text-gray-600':
                          tab != 'photos',
                      }"
                      class="-ml-0.5 mr-2 h-5 w-5"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span>Foto</span>
                  </a>
                </nav>
              </div>
            </div>
            <template v-if="patient.id" class="flex-shrink-0 ml-4">
              <div class="mt-4 flex md:mt-0 md:ml-4">
                <span class="shadow-sm rounded-md">
                  <button
                    @click="destroy"
                    type="button"
                    class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:shadow-outline-red focus:border-red-700 active:bg-red-700 transition duration-150 ease-in-out"
                  >
                    Elimina
                  </button>
                </span>
                <span class="ml-3 shadow-sm rounded-md">
                  <router-link
                    tag="button"
                    :to="`/patients/${patient.id}/examination/new`"
                    class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-500 hover:bg-indigo-400 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-600 active:bg-indigo-600 transition duration-150 ease-in-out"
                  >
                    <svg
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      class="w-5 h-5"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span class="ml-2">Visita</span>
                  </router-link>
                </span>
              </div>
            </template>
          </div>
        </div>

        <component :is="component"></component>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import { Italian } from "flatpickr/dist/l10n/it";
import CodiceFiscale from "calcolo-codice-fiscale";

import PatientInfo from "./PatientInfo";
import PatientFiles from "./PatientFiles";
import PatientPhotos from "./PatientPhotos";

export default {
  props: {
    id: {
      required: false,
    },
  },

  data: () => {
    return {
      loaded: false,
      tab: "",
    };
  },

  components: {
    PatientInfo,
    PatientFiles,
    PatientPhotos,
  },

  computed: {
    ...mapState("patient", ["patient"]),
    ...mapState("app", ["user", "cities"]),
    component() {
      return "patient-" + this.tab;
    },
  },

  methods: {
    city() {
      if (this.patient.city) {
        let city = this.cities.find((element) => {
          return element.nome.toUpperCase() == this.patient.city.toUpperCase();
        });
        this.patient.province = city.sigla;
        this.patient.zip = city.cap[0];
      }
    },
    birthplace() {
      if (this.patient.birthplace) {
        let city = this.cities.find((element) => {
          return (
            element.nome.toUpperCase() == this.patient.birthplace.toUpperCase()
          );
        });
        this.patient.birthplace_province = city.sigla;
      }
    },
    cf() {
      let dob = window.moment(this.patient.dob);
      let cf = CodiceFiscale.compute(
        this.patient.first_name,
        this.patient.last_name,
        this.patient.gender,
        dob.date(),
        dob.month() + 1,
        dob.year(),
        this.patient.birthplace,
        this.patient.birthplace_province
      );
      this.patient.cf = cf;
    },
    save() {
      this.$store.dispatch("patient/SAVE", this.patient);
    },
    destroy() {
      if (confirm("Sicuro di voler cancellare il paziente?")) {
        this.$store.dispatch("patient/DELETE");
        this.$router.go(-1);
      }
    },
  },

  async mounted() {
    this.tab =
      this.$router.currentRoute.hash.length > 1
        ? this.$router.currentRoute.hash.replace("#", "")
        : "info";
    this.$store.dispatch("patient/RESET");
    if (this.id) {
      await this.$store.dispatch("patient/PATIENT", { id: this.id });
    }
    this.loaded = true;
  },
};
</script>
